import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { UAVStatus } from '../../model/UAVStatus';

export interface UAVsState extends EntityState<UAVStatus> { }

const maxImageFeedLength = 10;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'UAVs' })
export class UAVsStore extends EntityStore<UAVsState> {

  constructor() {
    super();
  }

  akitaPreAddEntity(newUAV: UAVStatus) {
    const imageFeed = newUAV.media != null
      ? newUAV.media.filter(medium => medium.mediaType === 'IMAGE')
      : [];
    return { ...newUAV, imageFeed };
  }


}
